import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { GaugeChartBase, GaugeChartBaseProps } from './GaugeChartBase';

export type ResponsiveGaugeChartBaseProps = ResponsiveComponentProps<GaugeChartBaseProps>;

export function ResponsiveGaugeChartBase({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveGaugeChartBaseProps) {
  return (
    <ResponsiveWrapper width={overrideWidth} height={overrideHeight}>
      {({ width, height }) => {
        return <GaugeChartBase width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
